module.exports = __webpack_public_path__ + "img/Zirkl_running.b0faecb5.jpg";